import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
  root: {
    // height: 32,
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/common/checkbox/checkbox-styles.js